import { MessagePlugin } from 'tdesign-react';

import { CopyType } from '@/const/lits';
import { IChapter } from '@/interface';
import { transformObjectDeep } from '@/utils/tans/object';

import { apiPathServer } from './api-config';
import { CgiErrorCode, CgiResp } from './cgi';
import { API_PREFIX, request } from './request';

/**
 * 保存项目信息
 */
export const modifyChapterDetail = async (data: IChapter, release?: boolean) => {
  const res = await request(`${API_PREFIX}${apiPathServer.postChapter}${release ? '/release' : ''}`, {
    method: 'POST',
    body: transformObjectDeep({
      force: false,
      data,
    }, 'snake'),
  });
  return res;
};

/**
 * 删除项目信息
 */
export const deleteChapter = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.deleteChapter}`, {
    method: 'POST',
    body: { id },
  });
  return res;
};

/**
 * copy项目信息
 */
export const copySpace = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.copy}`, {
    method: 'POST',
    body: { copy_id: id, type: CopyType.SPACE },
  });
  return res;
};

/**
 * 拉取详情
 */
export const fetchChapterDetail = async ({ id = '', release = false }) => {
  const res = await request<CgiResp<IChapter>>(
    `${API_PREFIX}${apiPathServer.chapterDetail}${release ? '/release' : ''}`,
    {
      query: {
        id,
        depth: 3,
      },
    },
  );
  if (res?.code !== CgiErrorCode.NO_ERROR) {
    MessagePlugin.error(res?.message || '章节信息拉取失败，请稍后重试');
  }
  const turnData = transformObjectDeep(res?.data, 'camel') as IChapter;
  return {
    ...res,
    scenes: turnData?.sceneList || [],
    bots: [],
    chapterInfo: turnData,
  };
};

/**
 *  拉取章节列表
 * @param param
 * @returns
 */
export const fetchChapterList = async ({
  page = 1,
  size = 10,
  storyId = '',
}: {
  page?: number;
  size?: number;
  storyId: string
}): Promise<{
  list: IChapter[];
  pageInfo: {
    total: number;
    current: number;
    pageSize: number;
  }
}> => {
  const res = await request(`${API_PREFIX}${apiPathServer.chapterList}${storyId.includes('draft') ? '' : '/release'}`, {
    query: {
      page,
      size,
      story_id: storyId,
    },
  });
  const { list, pageinfo: pageInfo } = res?.data || { list: [] };
  return {
    list: list?.map((item: any) => transformObjectDeep(item, 'camel')) || [],
    pageInfo: {
      total: pageInfo?.total || 0,
      current: pageInfo?.page || 1,
      pageSize: pageInfo?.size || 10,
    },
  };
};
